// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import LayerLibraryGroup from './LayerLibraryGroup';
import BaseMap from '../../../enums/BaseMapTypes';
import {injectIntl} from "react-intl";
import BusComponent from "../../BusComponent";

const CUSTOM_LIBRARY_LAYER_IDS = [BaseMap.STREET];

 /**
  * @param {object} param0
  * @param {import('../../../').LayerDataGroupSHOULD_BE_REFACTORED[]} param0.libraryGroups
  * @param {string} param0.mapInstanceId
  * @param {string|undefined} param0.className
  * @param {import('../../../objects/LibraryLayer').default[]|undefined} param0.userLayers
*/
class LayerLibraryLegend extends BusComponent {
    constructor(props, context) {
        super(props, context);

        this._isMounted = false;
    }

     componentDidMount() {
         this._isMounted = true;
         this.bindGluBusEvents({
             MAP_LIBRARY_LAYERS_UPDATED: this.onLibraryLayersUpdated,
         });
     }

     componentWillUnmount() {
         this._isMounted = false;
     }


     onLibraryLayersUpdated = () => {
         // Toggle on visibility of the layer doesn't update DOM if you remove
         // this line.
         if (this._isMounted) {
             this.forceUpdate();
         }
    }

    render() {
        const { intl, libraryGroups, mapInstanceId, className, userLayers } = this.props;

        const groupItems = libraryGroups
            .filter(lg => CUSTOM_LIBRARY_LAYER_IDS.indexOf(lg.id) === -1)
            .map(layerGroup => {
                const { id, metadata, layers } = layerGroup;
                return (
                    <LayerLibraryGroup
                        key={id}
                        layers={layers}
                        layerLibraryGroupId={id}
                        mapInstanceId={mapInstanceId}
                        layerGroupMetadata={metadata}
                    />
                );
            });
        let userGroupItems = [];

        if (userLayers.length) {
            const layerGroupMetadata = {
                title: intl.formatMessage({ id: 'layerLibrary.userLayers' }),
                classes: userLayers.map(layer => ({
                    label: layer.title || intl.formatMessage({ id: 'layerLibrary.userLayers' }),
                    'layer-group-id': layer.id,
                    visible: layer.visible,
                    interactive: layer.interactive,
                    markerStyle: {
                        backgroundColor: layer.styleRules[0].markerColor,
                        color: 'white',
                        borderRadius: 999,
                        fontSize: 14,
                        padding: 4
                    },
                    icon: 'marker-'.concat(layer.styleRules[0].markerPathId),
                    isUserLayer: true
                }))
            };
            const userLayersKey = 'user-layer';

            userGroupItems.push(
                <LayerLibraryGroup
                    key={userLayersKey}
                    layers={userLayers}
                    layerLibraryGroupId={userLayersKey}
                    mapInstanceId={mapInstanceId}
                    layerGroupMetadata={layerGroupMetadata}
                />
            );
        }

        if (groupItems.length === 0) return null;

        const layerLibraryClasses = classNames(
            'layer-library-legend',
            className,
        );

        return (
            <div className={layerLibraryClasses}>
                {groupItems}
                {userGroupItems}
            </div>
        );
    };
}

LayerLibraryLegend.propTypes = {
    libraryGroups: PropTypes.array.isRequired,
    mapInstanceId: PropTypes.string.isRequired,
    className: PropTypes.string,
    userLayers: PropTypes.array,
};

LayerLibraryLegend.defaultProps = {
    className: undefined,
    userLayers: [],
};

export default injectIntl(LayerLibraryLegend);
